(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneRenaultHeaderMobile"] = factory();
	else
		root["@makolab/library-react/dist/OneRenaultHeaderMobile"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 317);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/withEventService");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderMobile", function() { return HeaderMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_event_service__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_event_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__commons_event_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_with_event_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_with_event_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__commons_with_event_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_icon__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__icon_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__one_renault_header_mobile_jss__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__one_renault_header_mobile_types__ = __webpack_require__(320);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderMobile=function(_Component){_inherits(HeaderMobile,_Component);function HeaderMobile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderMobile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderMobile.__proto__||Object.getPrototypeOf(HeaderMobile)).call.apply(_ref,[this].concat(args))),_this),_this.menuHandler=function(){__WEBPACK_IMPORTED_MODULE_4__commons_event_service___default.a.emit('header/menu-open',null);},_this.renderWording=function(_ref2){var className=_ref2.className,link=_ref2.link,text=_ref2.text;var classes=_this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:link,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.links)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Typography"],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes[className]),variant:'body1',component:'span'},text));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderMobile,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,url=_props.header.logo.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url,title:'Renault',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.logoLink)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 66 86',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.logoIcon)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M52.3 43l-23 43H23L0 43 22.9 0h6.5L6.5 43l19.6 36.9L45.7 43 34.3 21.5l3.3-6.1L52.3 43zM42.5 0h-6.6L13.1 43l14.7 27.6 3.2-6.1L19.6 43 39.2 6l19.6 37-22.9 43h6.6l22.8-43L42.5 0z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.title)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.button),onClick:this.menuHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon_icon___default.a,{id:'header-burger',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.buttonIcon),size:20}))));}}]);return HeaderMobile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HeaderMobile.displayName='HeaderMobile';HeaderMobile.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,header:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__one_renault_header_mobile_types__["a" /* HEADER_PROP_TYPE */]).isRequired,wording:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired// logo: PropTypes.shape(HEADER_LOGO_PROP_TYPE).isRequired
};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_9__one_renault_header_mobile_jss__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_5__commons_with_event_service___default()()])(HeaderMobile));

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core");

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(theme){var _root;return{root:(_root={display:'flex',alignItems:'center',justifyContent:'space-between',minHeight:60,borderBottom:'1px solid '+theme.palette.common.legalBorder,backgroundColor:theme.palette.primary.dark},_defineProperty(_root,theme.breakpoints.up('sm'),{minHeight:80}),_defineProperty(_root,theme.breakpoints.up('md'),{display:'none'}),_root),logo:{display:'block',flexShrink:0,height:40,margin:'auto 0 auto '+theme.spacing.unit+'px'},logoIcon:{width:'100%',fill:theme.palette.primary.white},logoLink:_defineProperty({width:27,marginTop:4,marginLeft:16},theme.breakpoints.up('sm'),{width:36}),title:{alignItems:'center',display:'flex',flexDirection:'row',fontSize:14,fontWeight:700,color:theme.palette.primary.dark},button:{height:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',border:0,padding:'0 16px 0 0',background:'none',textDecoration:'none',cursor:'pointer'},buttonIcon:{width:20,display:'block',fill:theme.palette.primary.white},buttonLabel:{marginTop:theme.spacing.unit/4,color:theme.palette.primary.dark,fontSize:'10px',textTransform:'capitalize'},currentSite:{color:theme.palette.primary.dark,fontFamily:['NouvelR-Bold','sans-serif'].join(', '),fontSize:14},leftButton:{paddingRight:16,marginRight:16,borderRight:'1px solid rgb(223, 228, 239)'},links:{alignItems:'center',display:'flex',justifyContent:'center',height:'100%',padding:theme.spacing.unit*2+'px '+theme.spacing.unit+'px',position:'relative',textDecoration:'none','&:first-of-type':{paddingLeft:16},'&:not(:first-of-type)':{'&:before':{position:'absolute',top:'50%',transform:'translateY(-50%)',content:'""',width:1,height:12,left:0,backgroundColor:theme.palette.common.linkSeparator}}}};});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HEADER_LOGO_PROP_TYPE */
/* unused harmony export HEADER_BUTTON_PROP_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEADER_PROP_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var HEADER_LOGO_PROP_TYPE={alt:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,imageMobile:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};var HEADER_BUTTON_PROP_TYPE={'@id':__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};var HEADER_PROP_TYPE={labelHome:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,currentWording:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,rangeUrl:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,currentSite:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,logo:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(HEADER_LOGO_PROP_TYPE).isRequired,buttons:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(HEADER_BUTTON_PROP_TYPE)).isRequired,links:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object).isRequired};

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/eventService");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/Icon");

/***/ })

/******/ });
});
//# sourceMappingURL=OneRenaultHeaderMobile.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneRenaultHeaderMobile.js
// module id = 552
// module chunks = 0